import React from 'react'
import { TruncateWithTooltip, type Variant } from '@sketch/components'
import { StyledPill } from './WorkspaceAuditLogTable.styles'
import { auditActions } from './auditActions'
import type { WorkspaceAuditLogItem } from './types'
import { toneForAuditItem, type AuditLogTone } from './auditLogTone'

const toneVariants = {
  positive: 'brand',
  negative: 'error-inverted',
  neutral: 'secondary',
} satisfies Record<AuditLogTone, Variant>

export interface AuditActionPillProps {
  item: WorkspaceAuditLogItem
}

export const AuditActionPill: React.FCC<AuditActionPillProps> = ({ item }) => {
  const label =
    (item.action && auditActions[item.action]?.label) || 'Unknown event'

  return (
    <StyledPill variant={toneVariants[toneForAuditItem(item)]}>
      <TruncateWithTooltip placement="top">{label}</TruncateWithTooltip>
    </StyledPill>
  )
}
